import React from "react";
import "../composants/styles/Style.css";

function Terms() {
  return (
    <div className="container-fluid ">
      <br />
      <br />
      <div className="row">
        <div className="col-12">
          <div className="section">
            <div className="privacy-policy">
              <h1>
                <span role="img" aria-label="document">
                  📄
                </span>{" "}
                Terms of Use
              </h1>

              <h2>
                <span role="img" aria-label="handshake">
                  🤝
                </span>{" "}
                Agreement
              </h2>
              <p>
                By downloading or using any of our BRIKTECH products, you agree
                to these Terms of Use. Please read them carefully.
              </p>

              <h2>
                <span role="img" aria-label="office building">
                  🏢
                </span>{" "}
                1. About Us
              </h2>
              <p>
                BRIKTECH is a limited liability company registered in Canada
                with the Canada Revenue Agency (CRA) under number 794216366. Our
                head office is located at 146 Curry Street, Moncton, NB, E1A3V8.
              </p>

              <h2>
                <span role="img" aria-label="smartphone">
                  📱
                </span>{" "}
                2. Use of Our Products
              </h2>
              <p>
                You may use our products (website, apps, mobile games, etc.) for
                personal, non-commercial purposes. Any abusive use, such as
                cheating or game modification, is strictly prohibited.
              </p>

              <h2>
                <span role="img" aria-label="light bulb">
                  💡
                </span>{" "}
                3. Intellectual Property
              </h2>
              <p>
                All content within our products (graphics, sound, code, text,
                etc.) belongs to the publisher (BRIKTECH). You are not allowed
                to copy, sell, or redistribute any of it without our permission.
              </p>

              <h2>
                <span role="img" aria-label="shopping cart">
                  🛒
                </span>{" "}
                4. In-App Purchases
              </h2>
              <p>
                Our products may include in-app purchases. These are optional
                and non-refundable, except in cases of technical error or where
                required by law.
              </p>

              <h2>
                <span role="img" aria-label="megaphone">
                  📢
                </span>{" "}
                5. Advertisements
              </h2>
              <p>
                Our products may display third-party ads. We are not responsible
                for the content of these ads or the services offered by these
                third parties.
              </p>

              <h2>
                <span role="img" aria-label="warning">
                  ⚠️
                </span>{" "}
                6. Limitation of Liability
              </h2>
              <p>
                We do not guarantee our products will be error-free, virus-free,
                or continuously available. We are not liable for any damages
                resulting from the use of our products.
              </p>

              <h2>
                <span role="img" aria-label="gear">
                  ⚙️
                </span>{" "}
                7. Changes
              </h2>
              <p>
                We reserve the right to update these terms at any time. Changes
                will be posted within our products or on our website.
              </p>

              <h2>
                <span role="img" aria-label="no entry">
                  🚫
                </span>{" "}
                8. Right to Act
              </h2>
              <p>
                We reserve the right to suspend or terminate access to the
                service at any time without notice or justification. Violations
                of these terms may result in suspension, data deletion,
                reporting to authorities, or legal action.
              </p>

              <h2>
                <span role="img" aria-label="email">
                  📬
                </span>{" "}
                9. Contact
              </h2>
              <p>
                For any questions, please contact us at:{" "}
                <strong>briktech@outlook.com</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  );
}

export default Terms;
